export default function(options) {
  return (defaultOptionValue = null) => {
    if (!defaultOptionValue) {
      return options;
    }

    // check if the default value has a match in the existing options; if so, we'll borrow the existing options
    // text. Otherwise we'll use the default value instead.
    const defaultOption = options.find(option => option.value === defaultOptionValue);

    const defaultEntry = {
      value: "--null--",
      key: "default",
      text: defaultOption ? defaultOption.text : defaultOptionValue,
    };

    return [defaultEntry, ...options];
  };
}
